import { DownloadOutlined } from "@ant-design/icons";
import { Button, Space, Table } from "antd";
import { useTranslation } from "react-i18next";

import UsersLinksList from "@/components/User/UsersLinksList";
import { useAppNotification } from "@/modules/app-notification";
import { downloadFileWithNotify } from "@/modules/file-downloader";
import {
  FlexContainerText,
  FlexContainerJsx,
  FlexContainerDate,
} from "@/modules/flex-container";
import ProjectBreadcrumb from "@/modules/project/project-breadcrumb";
import { StateTag } from "@/modules/state-tag";
import { TranslateCost } from "@/modules/translate";
import { truncate } from "@/utilities/string";

const Info = ({ project }) => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();
  const {
    name,
    reference,
    description,
    start_date,
    ancestors,
    due_date,
    revised_interventions_cost,
    state,
    users,
    documents,
  } = project;
  return (
    <Space orientation="vertical" size="middle">
      {name && (
        <FlexContainerText value={name} label={t("project:form.name.label")} />
      )}
      {reference && (
        <FlexContainerText
          value={reference}
          label={t("project:form.reference.label")}
        />
      )}
      {description && (
        <FlexContainerText
          value={description}
          label={t("project:form.description.label")}
        />
      )}
      {ancestors.length > 2 && (
        <FlexContainerJsx
          value={
            <ProjectBreadcrumb project={project} exclude={["organization"]} />
          }
          label={t("global:hierarchy")}
        />
      )}
      {users?.length > 0 && (
        <FlexContainerJsx
          label={t("intervention:form.users.label")}
          value={<UsersLinksList users={users} />}
        />
      )}
      {start_date && (
        <FlexContainerDate
          value={start_date}
          label={t("project:form.startDate.label")}
        />
      )}
      {due_date && (
        <FlexContainerDate
          value={due_date}
          label={t("project:form.dueDate.label")}
        />
      )}

      {state && (
        <FlexContainerJsx
          value={<StateTag value={state} type="project" />}
          label={t("project:form.status.label")}
        />
      )}

      {revised_interventions_cost && (
        <FlexContainerText
          value={<TranslateCost value={revised_interventions_cost} />}
          label={t("project:form.revisedInterventionsCost.label")}
        />
      )}

      {documents && (
        <FlexContainerJsx
          label={t("project:form.documents.label")}
          value={
            <Table
              showHeader={false}
              columns={[
                {
                  dataIndex: "url",
                  render: (url, { name }) => (
                    <Button
                      type="link"
                      onClick={() =>
                        downloadFileWithNotify({ url, name, notify })
                      }
                    >
                      {truncate(name, 35)}
                    </Button>
                  ),
                },
                {
                  dataIndex: "url",
                  render: (url, { name }) => (
                    <Button
                      type="text"
                      aria-label="download"
                      onClick={() =>
                        downloadFileWithNotify({ url, name, notify })
                      }
                    >
                      <DownloadOutlined />
                    </Button>
                  ),
                },
              ]}
              dataSource={documents}
              rowKey="id"
              pagination={false}
            />
          }
          fullWidth
        />
      )}
    </Space>
  );
};

export default Info;
